import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0C0C0C] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <img src="/assets/10_logo_ungrip_transparent.png" alt="UNGRIP" className="h-16 mx-auto mb-8" />
        <form onSubmit={submit} className="bg-[#141414] border border-[#242424] rounded-2xl p-7">
          <h1 className="font-display font-black uppercase text-3xl text-[#FFC20E] text-center">Area riservata</h1>
          <p className="text-white/50 text-center text-sm mt-1">Accedi alla dashboard UNGRIP</p>

          <label className="block mt-6 text-white/60 text-sm font-semibold uppercase">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full mt-1 rounded-lg bg-[#0C0C0C] border border-[#333] px-4 py-3 text-white outline-none focus:border-[#FFC20E]"
            data-testid="admin-email-input"
          />

          <label className="block mt-4 text-white/60 text-sm font-semibold uppercase">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full mt-1 rounded-lg bg-[#0C0C0C] border border-[#333] px-4 py-3 text-white outline-none focus:border-[#FFC20E]"
            data-testid="admin-password-input"
          />

          {error && <p className="mt-3 text-[#E63946] text-sm" data-testid="admin-login-error">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-6 rounded-full bg-[#FFC20E] text-[#0C0C0C] font-display font-extrabold uppercase text-lg py-3 hover:scale-[1.02] transition-transform disabled:opacity-60"
            data-testid="admin-login-button"
          >
            {loading ? "Accesso…" : "Entra"}
          </button>
        </form>
      </div>
    </div>
  );
}
